import { render, staticRenderFns } from "./DropdownNormal.vue?vue&type=template&id=069994c2&scoped=true"
import script from "./DropdownNormal.vue?vue&type=script&lang=js"
export * from "./DropdownNormal.vue?vue&type=script&lang=js"
import style0 from "./DropdownNormal.scss?vue&type=style&index=0&id=069994c2&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069994c2",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotIcon: require('/home/runner/_work/app-hotmart-digital-learning/app-hotmart-digital-learning/components/Atoms/Icon/Icon.vue').default})
